import React, { useState, useEffect } from "react";
import { ErmLayoutWrap, MedRecordTabContent } from "../ErmView";
import { useSelector } from "react-redux";

function PatientErmContainer(props) {
  // Lấy dữ liệu từ Redux
  const InterfaceTemplateDetails = useSelector(
    (state) => state?.InterfaceTemplateData?.data?.InterfaceTemplate || {}
  );
  const PatientEMR = InterfaceTemplateDetails?.PatientEMR;
  const statusTabActiveMedicalRecord = useSelector(
    (state) => state.statusTaskActiveTabMedicalRecord?.activeTab || null
  );

  // State để lưu isCurrentTask, panelHeight (nếu vẫn cần) và heightPatientMedRecord
  const [isCurrentTask, setIsCurrentTask] = useState(
    statusTabActiveMedicalRecord || "PatientErm"
  );
  const [panelHeight, setPanelHeight] = useState(0);
  const [heightPatientMedRecord, setHeightPatientMedRecord] = useState(0);

  // Cập nhật isCurrentTask khi tab thay đổi
  useEffect(() => {
    setIsCurrentTask(statusTabActiveMedicalRecord || "PatientErm");
  }, [statusTabActiveMedicalRecord]);

  // Lấy chiều cao từ ErmLayoutWrap (nếu bạn vẫn dùng)
  const handleHeightChange = (height) => {
    setPanelHeight(height);
  };

  // Check tồn tại và lấy height của #erm-nomarl-screen và #erm-full-screen
  useEffect(() => {
    const normalEl = document.getElementById("erm-nomarl-screen");
    const fullEl = document.getElementById("erm-full-screen");

    if (normalEl) {
      setHeightPatientMedRecord(normalEl.clientHeight);
    } else if (fullEl) {
      setHeightPatientMedRecord(fullEl.clientHeight);
    } else {
      console.warn('Không tìm thấy element với id="erm-nomarl-screen" hoặc "erm-full-screen"');
    }
  }, []); // chạy 1 lần sau khi mount

  return (
    <ErmLayoutWrap
      {...props}
      heading={PatientEMR?.emr_title?.Text || "Review"}
      isCurrentTask={isCurrentTask}
      onHeightChange={handleHeightChange}
    >
      <MedRecordTabContent
        {...props}
        isCurrentTask={isCurrentTask}
        panelHeight={panelHeight}
        heightPatientMedRecord={heightPatientMedRecord}
      />
    </ErmLayoutWrap>
  );
}

export default PatientErmContainer;